import styled from 'styled-components'
import {
	media,
	Breakpoints,
	WrapperBlock,
	gridTwo,
	textModels,
	themeObject,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)`
	${gridTwo}
	grid-template-columns: 1fr;
	grid-template-rows: auto auto;
	${media('column-gap: 80px;', Breakpoints.xl)};
`
export const Block = styled.div`
	box-shadow: 0 0 0 1px ${themeObject.colors.grey[200]};
	padding: 24px 32px;
	border-radius: 16px;
	color: ${themeObject.colors.grey[800]};
`
export const Title = styled.p`
	${textModels('notAdaptive', 'xl', '600')}
	text-align: left;
	margin-bottom: 12px;
`
export const Info = styled.p`
	${textModels('text', 'l', '400')}
	text-align: left;
`
export const Text = styled.p`
	${textModels('text', 'l', '400')}
	text-align: left;
`
